// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__3AN5e","logo":"MainNavigation_logo__3qV1E","nav":"MainNavigation_nav__3sjKu","active":"MainNavigation_active__adJkD"};